import { Component, inject, Input, LOCALE_ID } from '@angular/core';
import { TrackingFacadeService } from 'src/app/services/tracking/tracking-facade.service';
import { PromotionProps } from 'src/app/services/tracking/tealium.utils';
import { formatDate } from '@angular/common';

/**
 * Builds the gap-funding upsell promotion-spot entry from the upsell's actual data. Shared between the
 * receipt `purchase_complete` event (impression, in promotion_info) and the CTA click event so both
 * describe the same spot. The title mirrors the headline rendered in gapfunding-upsell.component.html.
 * `action` is stamped per event by the tracking facade (`promotion_shown` / `promotion_clicked`).
 */
export function buildGapfundingPromotion(dibsSalesDate: Date, locale: string): PromotionProps {
  const month = dibsSalesDate ? formatDate(dibsSalesDate, 'MMMM', locale) : '';
  return {
    name: 'gapfunding_upsell',
    title: `Vil du også spille med i næste lodtrækning til ${month}?`,
    type: 'banner',
    link: '/betaling/spil-med-nu',
    placement: 'receipt',
    position: 0,
    category: 'product',
    action: 'promotion_shown',
    ribbon_name: '',
  };
}

@Component({
  selector: 'app-gapfunding-upsell',
  templateUrl: 'gapfunding-upsell.component.html',
  styleUrls: ['./gapfunding-upsell.component.scss']
})

export class GapfundingUpsellComponent {
  @Input() pricePrMonth: number;
  @Input() dibsSalesDate: Date;
  @Input() onConfirmCreateGapFund: () => Promise<void>;

  private readonly trackingFacadeService = inject(TrackingFacadeService);
  private readonly locale = inject(LOCALE_ID);

  public async onCtaClick(): Promise<void> {
    this.trackingFacadeService.promotionClicked([buildGapfundingPromotion(this.dibsSalesDate, this.locale)]);
    await this.onConfirmCreateGapFund();
  }
}
